// TODO: 之后从ucConfig或者从什么插件里要注入自定义的替换策略
export const REPLACE_POLICY = [
  // WCard,
];